(function($){
    var animationExists = 0;
    function animationEntrance(winscroll, winheight){
        if(animationExists){
            let winheightsplit = winheight * 0.8;
            $(".will_animate").each(function(e){
                let animateEffect = this.getAttribute("animate-entrance");
                $(this).css("opacity","0");
                if(winscroll + winheightsplit >= $(this).offset().top){
                    $(this).css("opacity","1");
                    $(this).addClass("animate__animated").addClass(animateEffect);
                    $(this).removeClass("will_animate");
                }
            });
        }
    }

    $(document).on("ready", function(){
        animationExists = $(".will_animate").length ? 1 : 0;
        animationEntrance(window.scrollY, $(window).height());
    });

    $(window).on("scroll",function(){
        animationEntrance(window.scrollY, $(window).height());
    });

})(jQuery);